import { Grid, useEventCallback } from '@mui/material';
import { memo, useEffect, useMemo, useRef } from 'react';
import Document from './accordions/document';
import Subjects from './accordions/subjects';
import Sections from './accordions/sections';
import {
  DataWizardAct,
  LastStepVM,
  ParentVM,
  SectionVM,
  TextActVM,
} from 'civil-status/view-models/step-form';
import { SectionWizardUseCase, SubjectsWizardUseCase } from 'shell/models/subjects-wizard';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import TextAct from '../shared/text-act';
import {
  initialValuesParent,
  initialValuesSections,
} from 'civil-status/constants/initial-values-step';
import { KeySections, KeySubjects } from 'civil-status/constants/keys-subjects-section';
import { ItemVM } from 'shell/view-models/item';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { CivilStatusID } from 'shell/constants/civil-status';
import { ID_APPLICANT } from 'civil-status/constants/id-applicant';
import { RiconoscimentoGenitoreItaliano } from 'civil-status/constants/id-riconoscimento-genitore-italiano';
import { ParentChangedSurnameID } from 'civil-status/constants/id-parent-changed-surname';
import { GenitoreTrasmessoCittadinanaza } from 'civil-status/constants/id-genitore-trasmesso-cittadinanaza';
import { IDSentenceRecognition } from 'civil-status/constants/id-sentence-recognition';
import { IDTypologyConsent } from 'civil-status/constants/id-typology-consent';
import { IDAssenzo2 } from 'civil-status/constants/id-assenso';
import { MeasureExchangeSurnameID } from 'civil-status/constants/id-measure-exchange-surname';
import { ID_OPPOSITION } from './accordions/section/list/list-opposition';
import { ID_NUMBERS_WITNESSES } from './accordions/section/list/list-number';
import { typePresence } from 'civil-status/constants/type-presence';
import { IDImpediment } from 'civil-status/constants/id-impediment';
import { withInterprete } from 'civil-status/utils/with-interprete';
import { ID_PUBBLICATIONS } from './accordions/section/list/list-publication';
import { IDMinorAssistance } from 'civil-status/constants/id-minor-assistance';
import { IDTypeSeparation } from 'civil-status/constants/id-type-separation';
import { FormikProps } from 'formik';
import { IDLawer } from 'civil-status/constants/id-lawyer';
import { dataMaintenanceSection } from 'civil-status/constants/data-maintenance-section';
import TextAnnotationOld from './accordions/text-annotation-old';
import DocumentEmergency from './accordions/document-emergency';
import { DateTime } from 'luxon';
import { ID_TYPE_APPLICANT } from 'civil-status/constants/id-type-applicant';
import { numberCondition } from 'civil-status/utils/numbers-condition';
import { keyAllHolders } from 'civil-status/constants/key-all-holders';
import { keyAllChildren } from 'civil-status/constants/key-all-children';

interface LastStepProps {
  formContext: FormikProps<LastStepVM>;
  onSaveSubject: (values: ParentVM) => ResponsePromise<number | undefined> | void | undefined;
  onSaveSection: (values: SectionVM) => ResponsePromise<DataWizardAct> | void | undefined;
  onSaveText: (values?: TextActVM) => void;
  callGetTextAct: (startCall?: boolean) => void;
  idEvento?: number;
  codLastStep?: string;
  soggettiUseCaseData?: Array<SubjectsWizardUseCase>;
  sezioniUseCaseData?: Array<SectionWizardUseCase>;
  dateFormationAct?: string;
  tipoEvento?: string;
  idUseCase?: string;
  disabled?: boolean;
  withReasonDelay?: boolean;
  disabledValid?: boolean;
  disabledEmergency?: boolean;
  isLastStepEditAct?: boolean;
  isLastStepEmergency?: boolean;
  isStepFromEmergency?: boolean;
}

const LastStepComponent = ({
  formContext,
  onSaveSubject,
  onSaveSection,
  callGetTextAct,
  onSaveText,
  idEvento,
  codLastStep,
  soggettiUseCaseData,
  sezioniUseCaseData,
  dateFormationAct,
  tipoEvento,
  idUseCase,
  disabled = false,
  withReasonDelay = false,
  disabledValid = false,
  disabledEmergency = false,
  isLastStepEditAct = false,
  isLastStepEmergency = false,
  isStepFromEmergency = false,
}: LastStepProps): React.ReactElement => {
  // values Dati generali consenso
  const valuesDatiGenerali: SectionVM | undefined = useMemo(() => {
    return (
      formContext.values[KeySections.keyDatiGenerali] ||
      formContext.values[KeySections.keyDatiGen] ||
      formContext.values[KeySections.keyDatiGeneraliConsAssRico] ||
      formContext.values[KeySections.keyDatiGeneraliAssRico] ||
      formContext.values[KeySections.keyDatiGeneraliPresDoc] ||
      formContext.values[KeySections.keyDatiGeneraliConsRico] ||
      formContext.values[KeySections.keyDatiGeneraliConsAssCognridRico] ||
      formContext.values[KeySections.keyDatiGeneraliConsRicoSent] ||
      formContext.values[KeySections.keyDatiGeneraliConsRicoEvento] ||
      formContext.values[KeySections.keyDatiGeneraliRicoGen] ||
      formContext.values[KeySections.keyDatiGeneraliRiconoscimento] ||
      formContext.values[KeySections.keyDatiRiconciliazione] ||
      formContext.values[KeySections.keyDatiGeneraliNegoz]
    );
  }, [
    formContext.values[KeySections.keyDatiGenerali],
    formContext.values[KeySections.keyDatiGen],
    formContext.values[KeySections.keyDatiGeneraliConsAssRico],
    formContext.values[KeySections.keyDatiGeneraliAssRico],
    formContext.values[KeySections.keyDatiGeneraliPresDoc],
    formContext.values[KeySections.keyDatiGeneraliConsRico],
    formContext.values[KeySections.keyDatiGeneraliConsRicoEvento],
    formContext.values[KeySections.keyDatiGeneraliConsAssCognridRico],
    formContext.values[KeySections.keyDatiGeneraliRicoGen],
    formContext.values[KeySections.keyDatiGeneraliRiconoscimento],
    formContext.values[KeySections.keyDatiRiconciliazione],
    formContext.values[KeySections.keyDatiGeneraliNegoz],
  ]);

  // values sezione Genitore che trasmette cittadinanza
  const valuesGenitoreTrasmetteCittadinanza: SectionVM | undefined = useMemo(() => {
    return formContext.values[KeySections.keyGenitCheTrasmetteCit];
  }, [formContext.values[KeySections.keyGenitCheTrasmetteCit]]);

  // values sezione Richiesta Genitore Italiano
  const valuesRicGenitoreItaliano: SectionVM | undefined = useMemo(() => {
    return formContext.values[KeySections.keyRicGenitoreItaliano];
  }, [formContext.values[KeySections.keyRicGenitoreItaliano]]);

  // values sezione Dati Specifici Di Cittadinanza
  const valuesDatiSpecificiCittadinanza: SectionVM | undefined = useMemo(() => {
    return formContext.values[KeySections.keyDatiSpecificiCittadinanza];
  }, [formContext.values[KeySections.keyDatiSpecificiCittadinanza]]);

  const valuesTrascrizioneCittadinanza: SectionVM | undefined = useMemo(() => {
    return formContext.values[KeySections.keyTrascrizioneCittadinanza];
  }, [formContext.values[KeySections.keyTrascrizioneCittadinanza]]);

  const valuesDatiTrascrizione: SectionVM | undefined = useMemo(() => {
    return (
      formContext.values[KeySections.keyDatiTrascrizione] ||
      formContext.values[KeySections.keyDatiTrascrizioneSeparazione] ||
      formContext.values[KeySections.keyDatiTrascrizioneTpRichiedente] ||
      formContext.values[KeySections.keyDatiTrascrizioneTpRichiedenteFg] ||
      {}
    );
  }, [
    formContext.values[KeySections.keyDatiTrascrizione],
    formContext.values[KeySections.keyDatiTrascrizioneSeparazione],
    formContext.values[KeySections.keyDatiTrascrizioneTpRichiedente],
    formContext.values[KeySections.keyDatiTrascrizioneTpRichiedenteFg],
  ]);

  // values soggetto Interprete
  const valuesInterprete: ParentVM | undefined = useMemo(() => {
    return formContext.values[KeySubjects.keyInterprete];
  }, [formContext.values[KeySubjects.keyInterprete]]);

  // values soggetto Padre
  const valuesPadre: ParentVM | undefined = useMemo(() => {
    return formContext.values[KeySubjects.keyPadre];
  }, [formContext.values[KeySubjects.keyPadre]]);

  // values soggetto Madre
  const valuesMadre: ParentVM | undefined = useMemo(() => {
    return formContext.values[KeySubjects.keyMadre];
  }, [formContext.values[KeySubjects.keyMadre]]);

  // values soggetto Richiedente
  const valuesRichiedente: ParentVM | undefined = useMemo(() => {
    return formContext.values[KeySubjects.keyRichiedente];
  }, [formContext.values[KeySubjects.keyRichiedente]]);

  // values soggetto Richiedente Privato
  const valuesRichiedentePrivato: ParentVM | undefined = useMemo(() => {
    return formContext.values[KeySubjects.keyRichiedentePrivato];
  }, [formContext.values[KeySubjects.keyRichiedentePrivato]]);

  // values soggetto Avvocato
  const valuesAvvoc5: ParentVM | undefined = useMemo(() => {
    return formContext.values[KeySubjects.keyAvvoc5];
  }, [formContext.values[KeySubjects.keyAvvoc5]]);

  const valuesIntestNas: ParentVM | undefined = useMemo(() => {
    return (
      formContext.values[KeySubjects.keyIntNas] ||
      formContext.values[KeySubjects.keyIntNas2] ||
      formContext.values[KeySubjects.keyIntNas2C1]
    );
  }, [
    formContext.values[KeySubjects.keyIntNas],
    formContext.values[KeySubjects.keyIntNas2],
    formContext.values[KeySubjects.keyIntNas2C1],
  ]);

  const valuesDeceduto: ParentVM | undefined = useMemo(() => {
    return formContext.values[KeySubjects.keyDeceduto];
  }, [formContext.values[KeySubjects.keyDeceduto]]);

  const valuesAttoAssenzaFiglio: SectionVM = useMemo(() => {
    return formContext.values[KeySections.keyAttoAssensoFiglio] || {};
  }, [formContext.values[KeySections.keyAttoAssensoFiglio]]);

  const valuesSpecificCivilUnionMarriage: SectionVM = useMemo(() => {
    return (
      formContext.values[KeySections.keyDatiSpecificiUniciv] ||
      formContext.values[KeySections.keyDatiSpecificiMatr] ||
      {}
    );
  }, [
    formContext.values[KeySections.keyDatiSpecificiUniciv],
    formContext.values[KeySections.keyDatiSpecificiMatr],
  ]);

  const valuesDatiSepar: SectionVM = useMemo(() => {
    return (
      formContext.values[KeySections.keyDatiSepar] ||
      formContext.values[KeySections.keyDatiSeparUC] ||
      {}
    );
  }, [
    formContext.values[KeySections.keyDatiSepar],
    formContext.values[KeySections.keyDatiSeparUC],
  ]);

  const valuesRegimePatrimoniale: SectionVM = useMemo(() => {
    return formContext.values[KeySections.keyRegimePatrimoniale] || {};
  }, [formContext.values[KeySections.keyRegimePatrimoniale]]);

  const valuesIntest1: ParentVM = useMemo(() => {
    return formContext.values[KeySubjects.keyIntest1] || {};
  }, [formContext.values[KeySubjects.keyIntest1]]);

  const dataMaintenanceSubject = useEventCallback(
    (currentSubject: ParentVM | undefined): ParentVM => {
      return {
        nameSubject: currentSubject?.nameSubject,
        codeSubject: currentSubject?.codeSubject,
        configuration: currentSubject?.configuration || '',
        flagComparente: currentSubject?.flagComparente || '',
        flagDichiarante: currentSubject?.flagDichiarante || '',
        tipoSoggetto: currentSubject?.tipoSoggetto || '',
        flagFirmatario: currentSubject?.flagFirmatario || '',
        presenza: currentSubject?.presenza || '',
        isSaved: currentSubject?.isSaved,
      };
    }
  );

  // Funzione che setta i dati dipendenti da altri valori che ne determina l'obbligatorietà, effettuato un solo punto di accesso per l'aggiornamento dello stato e resetta tutti i campi se non va mostrato
  const setDependentData = useEventCallback(
    (
      isWithInterprete?: boolean,
      sentenceRecognition?: string,
      typologyConsentAndConfiguration?: ItemVM, // id = configurazione, value = value of the typologyConsent field
      typeDeclaration?: string,
      isIncestuousSonSentence?: boolean,
      parentTransmittedCitizenship?: string,
      parentRecognition?: string,
      intNasCivilStatus?: string,
      parentRecognitionSection?: string,
      isPaternitySentence?: boolean,
      sentenceRecognitionNameSurname?: string,
      applicant?: string,
      parentRecognitionSectionOnlyRiconsocimentoMadrePadre?: string,
      parentChangedSurname?: string,
      measureExchangeSurname?: string,
      opposition?: string,
      genericImpediment?: string,
      propertyRegime?: string,
      numberWitnesses?: string,
      impedimentUnitedCivilly?: string,
      publication?: string,
      minorGroomAssistance?: string,
      minorWifeAssistance?: string,
      ageDefect?: string,
      isTemporaryBanRemarriage?: boolean,
      relationship?: string,
      isLawyerHusband?: boolean,
      isLawyerWife?: boolean,
      typeSeparation?: string,
      isReceivedPrivateCitizen?: boolean,
      isSonUnderFourteen?: boolean,
      isChangeSurnameName?: boolean,
      isReceivedByPost?: boolean,
      decedutoCivilStatus?: string,
      isLastStepEmergencyCurr?: boolean,
      typeApplicant?: string,
      numberHolders?: string,
      numberChildren?: string,
      isLawyerHusbandWife?: boolean
    ) => {
      let newValues = { ...formContext.values };

      if (typeof isWithInterprete === 'boolean') {
        newValues = {
          ...newValues,
          [KeySubjects.keyInterprete]: {
            ...dataMaintenanceSubject(valuesInterprete),
            generality: {
              ...(isWithInterprete || valuesInterprete?.presenza === typePresence.Obbligatorio
                ? (valuesInterprete || {})?.generality || initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isWithInterprete,
              idSubject: valuesInterprete?.generality?.idSubject,
            },
          } as ParentVM,
        };
      }

      if (sentenceRecognition) {
        newValues = {
          ...newValues,
          [KeySections.keyEstremiSentenzaMadre]: {
            ...(sentenceRecognition === IDSentenceRecognition.Riconoscimento4
              ? formContext.values[KeySections.keyEstremiSentenzaMadre] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyEstremiSentenzaMadre]),
            isRequiredFromOtherAccordion:
              sentenceRecognition === IDSentenceRecognition.Riconoscimento4,
          } as SectionVM,
          [KeySections.keyEstremiSentenzaPadre]: {
            ...(sentenceRecognition === IDSentenceRecognition.Riconoscimento3
              ? formContext.values[KeySections.keyEstremiSentenzaPadre] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyEstremiSentenzaPadre]),
            isRequiredFromOtherAccordion:
              sentenceRecognition === IDSentenceRecognition.Riconoscimento3,
          },
          [KeySections.keyAttoConsensoAtcop]: {
            ...(sentenceRecognition === IDSentenceRecognition.Riconoscimento2
              ? formContext.values[KeySections.keyAttoConsensoAtcop] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoConsensoAtcop]),
            isRequiredFromOtherAccordion:
              sentenceRecognition === IDSentenceRecognition.Riconoscimento2,
          },
          [KeySections.keyAttoConsensoAtcom]: {
            ...(sentenceRecognition === IDSentenceRecognition.Riconoscimento1
              ? formContext.values[KeySections.keyAttoConsensoAtcom] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoConsensoAtcom]),
            isRequiredFromOtherAccordion:
              sentenceRecognition === IDSentenceRecognition.Riconoscimento1,
          },
        };
      }

      if (typeof isIncestuousSonSentence === 'boolean') {
        newValues = {
          ...newValues,
          [KeySections.keyAutorizzazioneRiconoscimentoPadre]: {
            ...(isIncestuousSonSentence
              ? formContext.values[KeySections.keyAutorizzazioneRiconoscimentoPadre] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyAutorizzazioneRiconoscimentoPadre]
            ),
            isRequiredFromOtherAccordion: isIncestuousSonSentence,
          } as SectionVM,
        };
      }

      if (typeof isPaternitySentence === 'boolean') {
        newValues = {
          ...newValues,
          [KeySections.keyEstremiSentenzaPadre]: {
            ...(isPaternitySentence
              ? formContext.values[KeySections.keyEstremiSentenzaPadre] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyEstremiSentenzaPadre]),
            isRequiredFromOtherAccordion: isPaternitySentence,
          } as SectionVM,
          [KeySections.keyAttoRiconoscimentoPadre]: {
            ...(!isPaternitySentence
              ? formContext.values[KeySections.keyAttoRiconoscimentoPadre] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoRiconoscimentoPadre]),
            isRequiredFromOtherAccordion: !isPaternitySentence,
          } as SectionVM,
        };
      }

      if (
        parentTransmittedCitizenship ||
        sentenceRecognition ||
        parentRecognition ||
        sentenceRecognitionNameSurname ||
        applicant ||
        parentChangedSurname
      ) {
        // in questi casi si gestisce madre e padre
        const isMadre =
          parentTransmittedCitizenship === GenitoreTrasmessoCittadinanaza.trasmissione1 ||
          parentTransmittedCitizenship === GenitoreTrasmessoCittadinanaza.trasmissione3 ||
          sentenceRecognition === IDSentenceRecognition.Riconoscimento1 ||
          sentenceRecognition === IDSentenceRecognition.Riconoscimento4 ||
          sentenceRecognitionNameSurname === IDSentenceRecognition.Riconoscimento1 ||
          sentenceRecognitionNameSurname === IDSentenceRecognition.Riconoscimento4 ||
          parentRecognition === RiconoscimentoGenitoreItaliano.Madre ||
          parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi ||
          parentChangedSurname === ParentChangedSurnameID.Madre ||
          applicant === ID_APPLICANT.MADRE ||
          applicant === ID_APPLICANT.MADRE_PADRE;
        const isPadre =
          sentenceRecognition === IDSentenceRecognition.Riconoscimento2 ||
          sentenceRecognition === IDSentenceRecognition.Riconoscimento3 ||
          sentenceRecognitionNameSurname === IDSentenceRecognition.Riconoscimento2 ||
          sentenceRecognitionNameSurname === IDSentenceRecognition.Riconoscimento3 ||
          parentTransmittedCitizenship === GenitoreTrasmessoCittadinanaza.trasmissione2 ||
          parentTransmittedCitizenship === GenitoreTrasmessoCittadinanaza.trasmissione3 ||
          parentRecognition === RiconoscimentoGenitoreItaliano.Padre ||
          parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi ||
          parentChangedSurname === ParentChangedSurnameID.Padre ||
          applicant === ID_APPLICANT.PADRE ||
          applicant === ID_APPLICANT.MADRE_PADRE;

        newValues =
          valuesMadre?.presenza === typePresence.Condizionato ||
          valuesMadre?.presenza === typePresence.FacoltativoObbligatorio
            ? {
                ...newValues,
                [KeySubjects.keyMadre]: {
                  ...dataMaintenanceSubject(valuesMadre),
                  generality: {
                    ...(isMadre || valuesMadre?.presenza === typePresence.FacoltativoObbligatorio
                      ? (valuesMadre || {})?.generality || initialValuesParent?.generality
                      : initialValuesParent?.generality),
                    isRequiredFromOtherAccordion: isMadre,
                  },
                } as ParentVM,
              }
            : newValues;

        newValues =
          valuesPadre?.presenza === typePresence.Condizionato ||
          valuesPadre?.presenza === typePresence.FacoltativoObbligatorio
            ? {
                ...newValues,
                [KeySubjects.keyPadre]: {
                  ...dataMaintenanceSubject(valuesPadre),
                  generality: {
                    ...(isPadre || valuesPadre?.presenza === typePresence.FacoltativoObbligatorio
                      ? (valuesPadre || {})?.generality || initialValuesParent?.generality
                      : initialValuesParent?.generality),
                    isRequiredFromOtherAccordion: isPadre,
                  },
                } as ParentVM,
              }
            : newValues;
      }

      if (applicant) {
        const keyNascituro = (formContext.values[KeySubjects.keyIntNas] as ParentVM)?.codeSubject
          ? KeySubjects.keyIntNas
          : KeySubjects.keyIntNas2;
        const valuesNascituro = formContext.values[keyNascituro] || {};
        const isTratxBasrn = Boolean(
          Object.keys(formContext.values).find(
            (item) =>
              (item as SectionVM).configuration === ConfigurationType.TRATXBASRN ||
              (item as SectionVM).configuration === ConfigurationType.TRATXBASRO ||
              (item as SectionVM).configuration === ConfigurationType.TRATXTBASF
          )
        );

        newValues =
          valuesRichiedente?.presenza === typePresence.Condizionato
            ? {
                ...newValues,
                [KeySubjects.keyRichiedente]: {
                  ...dataMaintenanceSubject(valuesRichiedente),
                  generality: {
                    ...(applicant === ID_APPLICANT.ALTRO
                      ? (valuesRichiedente || {})?.generality || initialValuesParent?.generality
                      : initialValuesParent?.generality),
                    isRequiredFromOtherAccordion: applicant === ID_APPLICANT.ALTRO,
                    idSubject: valuesRichiedente?.generality?.idSubject,
                  },
                } as ParentVM,
              }
            : newValues;

        newValues =
          valuesNascituro?.presenza === typePresence.Condizionato
            ? {
                ...newValues,
                [keyNascituro]: isTratxBasrn
                  ? { ...(valuesNascituro || {}) }
                  : ({
                      ...dataMaintenanceSubject(valuesNascituro),
                      generality: {
                        ...(applicant === ID_APPLICANT.SOGGETTO
                          ? valuesNascituro?.generality || initialValuesParent?.generality
                          : initialValuesParent?.generality),
                        isRequiredFromOtherAccordion: applicant === ID_APPLICANT.SOGGETTO,
                      },
                    } as ParentVM),
              }
            : newValues;

        // Sezione DATI_AUTORITA_MITTENTE (config TRASDATIAV): condizionata dal
        // richiedente = Autorità giurisdizionale. Quando presente deve essere
        // obbligatoria (schemaTRASDATIAVC legge isRequiredFromOtherAccordion).
        newValues = {
          ...newValues,
          [KeySections.keyDatiAutoritaMittente]: {
            ...(applicant === ID_APPLICANT.AUTORITA_GIURISDIZIONALE
              ? formContext.values[KeySections.keyDatiAutoritaMittente] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyDatiAutoritaMittente]),
            isRequiredFromOtherAccordion: applicant === ID_APPLICANT.AUTORITA_GIURISDIZIONALE,
          },
        };
      }

      if (typologyConsentAndConfiguration?.value) {
        const keyConsenso2 =
          typologyConsentAndConfiguration.id === ConfigurationType.MADTSP5
            ? KeySections.keyConsensoAtto
            : typologyConsentAndConfiguration.id === ConfigurationType.RICDGCSSE
            ? KeySections.keyAttoDiConsensoAtcoP
            : KeySections.keyAttoDiConsensoAtco;
        const keyConsenso3 =
          typologyConsentAndConfiguration.id === ConfigurationType.MADTSP5
            ? KeySections.keyConsensoAltro
            : KeySections.keyAttoDiConsensoEd;
        const keyConsenso4 = Boolean(formContext.values[KeySections.keyConsensoSentenza])
          ? KeySections.keyConsensoSentenza
          : KeySections.keySentenzaConsenso;

        newValues = {
          ...newValues,
          [keyConsenso2]: {
            ...(typologyConsentAndConfiguration?.value === IDTypologyConsent.Consenso2
              ? formContext.values[keyConsenso2] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[keyConsenso2]),
            isRequiredFromOtherAccordion:
              typologyConsentAndConfiguration?.value === IDTypologyConsent.Consenso2,
          } as SectionVM,
          [keyConsenso3]: {
            ...(typologyConsentAndConfiguration?.value === IDTypologyConsent.Consenso3
              ? formContext.values[keyConsenso3] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[keyConsenso3]),
            isRequiredFromOtherAccordion:
              typologyConsentAndConfiguration?.value === IDTypologyConsent.Consenso3,
          },
          [keyConsenso4]: {
            ...(typologyConsentAndConfiguration?.value === IDTypologyConsent.Consenso4
              ? formContext.values[keyConsenso4] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[keyConsenso4]),
            isRequiredFromOtherAccordion:
              typologyConsentAndConfiguration?.value === IDTypologyConsent.Consenso4,
          },
        };
      }

      if (Boolean(typeDeclaration)) {
        newValues = {
          ...newValues,
          [KeySections.keyAttoAssensoFiglio]: {
            ...(typeDeclaration === IDAssenzo2
              ? valuesAttoAssenzaFiglio || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoAssensoFiglio]),
            isRequiredFromOtherAccordion: typeDeclaration === IDAssenzo2,
          },
          [KeySections.keyAttoAssensoFiglioReso]: {
            ...(typeDeclaration === IDAssenzo2
              ? formContext.values[KeySections.keyAttoAssensoFiglioReso] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoAssensoFiglioReso]),
            isRequiredFromOtherAccordion: typeDeclaration === IDAssenzo2,
          },
        };
      }

      if (intNasCivilStatus) {
        const isKeyAttoMatrimonio = intNasCivilStatus === CivilStatusID.coniugato;
        const isKeyAttoUnioneCivile = intNasCivilStatus === CivilStatusID.unitoCivilmente;
        const isKeyAttoNascitaConiuge =
          intNasCivilStatus === CivilStatusID.coniugato ||
          intNasCivilStatus === CivilStatusID.vedovo;
        const isKeyAttoNascitaUnito =
          intNasCivilStatus === CivilStatusID.unitoCivilmente ||
          intNasCivilStatus === CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso;
        const isConiuge =
          intNasCivilStatus === CivilStatusID.vedovo ||
          intNasCivilStatus === CivilStatusID.coniugato;
        const isUnitoCivilmente =
          intNasCivilStatus === CivilStatusID.unitoCivilmente ||
          intNasCivilStatus === CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso;

        newValues = {
          ...newValues,
          [KeySections.keyAttoNascitaConiuge]: {
            ...(isKeyAttoNascitaConiuge
              ? formContext.values[KeySections.keyAttoNascitaConiuge] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoNascitaConiuge]),
            isRequiredFromOtherAccordion: isKeyAttoNascitaConiuge,
          },
          [KeySections.keyAttoMatrimonio]: {
            ...(isKeyAttoMatrimonio
              ? formContext.values[KeySections.keyAttoMatrimonio] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoMatrimonio]),
            isRequiredFromOtherAccordion: isKeyAttoMatrimonio,
          },
          [KeySections.keyAttoUnioneCivile]: {
            ...(isKeyAttoUnioneCivile
              ? formContext.values[KeySections.keyAttoUnioneCivile] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoUnioneCivile]),
            isRequiredFromOtherAccordion: isKeyAttoUnioneCivile,
          },
          [KeySections.keyAttoNascitaUnito]: {
            ...(isKeyAttoNascitaUnito
              ? formContext.values[KeySections.keyAttoNascitaUnito] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoNascitaUnito]),
            isRequiredFromOtherAccordion: isKeyAttoNascitaUnito,
          },
          [KeySubjects.keyConiuge]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyConiuge] || {}),
            generality: {
              ...(isConiuge
                ? (formContext.values[KeySubjects.keyConiuge] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isConiuge,
            },
          } as ParentVM,
          [KeySubjects.keyUnitoCivilmente]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyUnitoCivilmente] || {}),
            generality: {
              ...(isUnitoCivilmente
                ? (formContext.values[KeySubjects.keyUnitoCivilmente] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isUnitoCivilmente,
            },
          } as ParentVM,
        };
      }

      if (decedutoCivilStatus) {
        const isKeyAttoMatrimonio = decedutoCivilStatus === CivilStatusID.coniugato;
        const isKeyAttoUnioneCivile = decedutoCivilStatus === CivilStatusID.unitoCivilmente;

        newValues = {
          ...newValues,
          [KeySections.keyAttoMatrimonio]: {
            ...(isKeyAttoMatrimonio
              ? formContext.values[KeySections.keyAttoMatrimonio] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoMatrimonio]),
            isRequiredFromOtherAccordion: isKeyAttoMatrimonio,
          },
          [KeySections.keyAttoUnioneCivile]: {
            ...(isKeyAttoUnioneCivile
              ? formContext.values[KeySections.keyAttoUnioneCivile] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoUnioneCivile]),
            isRequiredFromOtherAccordion: isKeyAttoUnioneCivile,
          },
        };
      }

      if (parentRecognitionSection || parentRecognitionSectionOnlyRiconsocimentoMadrePadre) {
        const isKeyAttoRiconoscimentoMadre = parentRecognitionSectionOnlyRiconsocimentoMadrePadre
          ? parentRecognitionSectionOnlyRiconsocimentoMadrePadre ===
            RiconoscimentoGenitoreItaliano.Madre
          : parentRecognitionSection === RiconoscimentoGenitoreItaliano.Madre;
        const isKeyAttoRiconoscimentoPadre = parentRecognitionSectionOnlyRiconsocimentoMadrePadre
          ? parentRecognitionSectionOnlyRiconsocimentoMadrePadre ===
            RiconoscimentoGenitoreItaliano.Padre
          : parentRecognitionSection === RiconoscimentoGenitoreItaliano.Padre;
        const isKeyAttoRiconoscimentoEntrambi =
          parentRecognitionSectionOnlyRiconsocimentoMadrePadre ===
          RiconoscimentoGenitoreItaliano.Entrambi;

        newValues = {
          ...newValues,
          [KeySections.keyAttoRiconoscimentoMadre]: {
            ...(isKeyAttoRiconoscimentoMadre
              ? formContext.values[KeySections.keyAttoRiconoscimentoMadre] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoRiconoscimentoMadre]),
            isRequiredFromOtherAccordion: isKeyAttoRiconoscimentoMadre,
          },
          [KeySections.keyAttoRiconoscimentoPadre]: {
            ...(isKeyAttoRiconoscimentoPadre
              ? formContext.values[KeySections.keyAttoRiconoscimentoPadre] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoRiconoscimentoPadre]),
            isRequiredFromOtherAccordion: isKeyAttoRiconoscimentoPadre,
          },
          [KeySections.keyAttoRiconoscimento]: {
            ...(isKeyAttoRiconoscimentoEntrambi
              ? formContext.values[KeySections.keyAttoRiconoscimento] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAttoRiconoscimento]),
            isRequiredFromOtherAccordion: isKeyAttoRiconoscimentoEntrambi,
          },
        };
      }

      if (measureExchangeSurname) {
        newValues = {
          ...newValues,
          [KeySections.keyDatiProvcom]: {
            ...(measureExchangeSurname === MeasureExchangeSurnameID.Prefettura
              ? formContext.values[KeySections.keyDatiProvcom] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyDatiProvcom]),
            isRequiredFromOtherAccordion:
              measureExchangeSurname === MeasureExchangeSurnameID.Prefettura,
          },
        };
      }

      if (opposition) {
        newValues = {
          ...newValues,
          [KeySections.keyProvvedimentoEstinzioneOpposizione]: {
            ...(opposition === ID_OPPOSITION.ID_PROVVEDIMENTO
              ? formContext.values[KeySections.keyProvvedimentoEstinzioneOpposizione] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyProvvedimentoEstinzioneOpposizione]
            ),
            isRequiredFromOtherAccordion: opposition === ID_OPPOSITION.ID_PROVVEDIMENTO,
          },
          [KeySections.keyProvvedimentoRigettoOpposizione]: {
            ...(opposition === ID_OPPOSITION.ID_DECRETO
              ? formContext.values[KeySections.keyProvvedimentoRigettoOpposizione] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyProvvedimentoRigettoOpposizione]
            ),
            isRequiredFromOtherAccordion: opposition === ID_OPPOSITION.ID_DECRETO,
          },
        };
      }

      if (genericImpediment) {
        newValues = {
          ...newValues,
          [KeySections.keyCertImpedimentoGenerico]: {
            ...(genericImpediment !== '0'
              ? formContext.values[KeySections.keyCertImpedimentoGenerico] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyCertImpedimentoGenerico]),
            isRequiredFromOtherAccordion: genericImpediment !== '0',
          },
        };
      }

      if (impedimentUnitedCivilly) {
        newValues = {
          ...newValues,
          [KeySections.keyCertImpedimentoGenericoSposo]: {
            ...(impedimentUnitedCivilly === IDImpediment.Sposo ||
            impedimentUnitedCivilly === IDImpediment.Entrambi
              ? formContext.values[KeySections.keyCertImpedimentoGenericoSposo] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyCertImpedimentoGenericoSposo]
            ),
            isRequiredFromOtherAccordion:
              impedimentUnitedCivilly === IDImpediment.Sposo ||
              impedimentUnitedCivilly === IDImpediment.Entrambi,
          },
          [KeySections.keyCertImpedimentoGenericoSposa]: {
            ...(impedimentUnitedCivilly === IDImpediment.Sposa ||
            impedimentUnitedCivilly === IDImpediment.Entrambi
              ? formContext.values[KeySections.keyCertImpedimentoGenericoSposa] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyCertImpedimentoGenericoSposa]
            ),
            isRequiredFromOtherAccordion:
              impedimentUnitedCivilly === IDImpediment.Sposa ||
              impedimentUnitedCivilly === IDImpediment.Entrambi,
          },
        };
      }

      if (propertyRegime) {
        newValues = {
          ...newValues,
          [KeySections.keyAnnotazioneContestuale]: {
            ...(formContext.values[KeySections.keyAnnotazioneContestuale] || initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAnnotazioneContestuale]),
            isRequiredFromOtherAccordion: propertyRegime !== '1',
          },
        };
      }

      if (numberWitnesses) {
        const is3 = numberWitnesses === ID_NUMBERS_WITNESSES.ID_3;
        const is4 = numberWitnesses === ID_NUMBERS_WITNESSES.ID_4;

        newValues = {
          ...newValues,
          [KeySubjects.keyTestimone3]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyTestimone3] || {}),
            generality: {
              ...(is3 || is4
                ? (formContext.values[KeySubjects.keyTestimone3] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: is3 || is4,
            },
          } as ParentVM,
          [KeySubjects.keyTestimone4]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyTestimone4] || {}),
            generality: {
              ...(is4
                ? (formContext.values[KeySubjects.keyTestimone4] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: is4,
            },
          } as ParentVM,
        };
      }

      if (publication) {
        newValues = {
          ...newValues,
          [KeySections.keyPubblicazione2]: {
            ...(publication === ID_PUBBLICATIONS.ID_PUBBLICATION_OCCURRED
              ? formContext.values[KeySections.keyPubblicazione2] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyPubblicazione2]),
            isRequiredFromOtherAccordion: publication === ID_PUBBLICATIONS.ID_PUBBLICATION_OCCURRED,
          },
          [KeySections.keyMatrimonioSentenzaOmissionePubblicazione]: {
            ...(publication === ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION
              ? formContext.values[KeySections.keyMatrimonioSentenzaOmissionePubblicazione] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyMatrimonioSentenzaOmissionePubblicazione]
            ),
            isRequiredFromOtherAccordion: publication === ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION,
          },
          [KeySections.keyPubblicazione1]: {
            ...(publication !== ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION
              ? formContext.values[KeySections.keyPubblicazione1] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyPubblicazione1]),
            isRequiredFromOtherAccordion: publication !== ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION,
          },
        };
      }

      if (minorGroomAssistance) {
        const isPadreSposo =
          minorGroomAssistance === IDMinorAssistance.Padre ||
          minorGroomAssistance === IDMinorAssistance.Entrambi;
        const isMadreSposo =
          minorGroomAssistance === IDMinorAssistance.Madre ||
          minorGroomAssistance === IDMinorAssistance.Entrambi;
        const isTutore = minorGroomAssistance === IDMinorAssistance.Tutore;
        const isCuratore = minorGroomAssistance === IDMinorAssistance.Curatore;

        newValues = {
          ...newValues,
          [KeySubjects.keyPadreSposo]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyPadreSposo]),
            generality: {
              ...(isPadreSposo
                ? (formContext.values[KeySubjects.keyPadreSposo] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isPadreSposo,
            },
          } as ParentVM,
          [KeySubjects.keyMadreSposo]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyMadreSposo]),
            generality: {
              ...(isMadreSposo
                ? (formContext.values[KeySubjects.keyMadreSposo] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isMadreSposo,
            },
          } as ParentVM,
          [KeySubjects.keyTutoreSposo]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyTutoreSposo]),
            generality: {
              ...(isTutore
                ? (formContext.values[KeySubjects.keyTutoreSposo] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isTutore,
            },
          } as ParentVM,
          [KeySubjects.keyCuratoreSposo]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyCuratoreSposo]),
            generality: {
              ...(isCuratore
                ? (formContext.values[KeySubjects.keyCuratoreSposo] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isCuratore,
            },
          } as ParentVM,
          [KeySections.keyMatrimonioNominaAssistenteLegaleSposo]: {
            ...(isTutore || isCuratore
              ? formContext.values[KeySections.keyMatrimonioNominaAssistenteLegaleSposo] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyMatrimonioNominaAssistenteLegaleSposo]
            ),
            isRequiredFromOtherAccordion: isTutore || isCuratore,
          },
        };
      }

      if (minorWifeAssistance) {
        const isPadreSposa =
          minorWifeAssistance === IDMinorAssistance.Padre ||
          minorWifeAssistance === IDMinorAssistance.Entrambi;
        const isMadreSposa =
          minorWifeAssistance === IDMinorAssistance.Madre ||
          minorWifeAssistance === IDMinorAssistance.Entrambi;
        const isTutore = minorWifeAssistance === IDMinorAssistance.Tutore;
        const isCuratore = minorWifeAssistance === IDMinorAssistance.Curatore;

        newValues = {
          ...newValues,
          [KeySubjects.keyPadreSposa]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyPadreSposa]),
            generality: {
              ...(isPadreSposa
                ? (formContext.values[KeySubjects.keyPadreSposa] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isPadreSposa,
            },
          } as ParentVM,
          [KeySubjects.keyMadreSposa]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyMadreSposa]),
            generality: {
              ...(isMadreSposa
                ? (formContext.values[KeySubjects.keyMadreSposa] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isMadreSposa,
            },
          } as ParentVM,
          [KeySubjects.keyTutoreSposa]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyTutoreSposa]),
            generality: {
              ...(isTutore
                ? (formContext.values[KeySubjects.keyTutoreSposa] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isTutore,
            },
          } as ParentVM,
          [KeySubjects.keyCuratoreSposa]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyCuratoreSposa]),
            generality: {
              ...(isCuratore
                ? (formContext.values[KeySubjects.keyCuratoreSposa] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isCuratore,
            },
          } as ParentVM,
          [KeySections.keyMatrimonioNominaAssistenteLegaleSposa]: {
            ...(isTutore || isCuratore
              ? formContext.values[KeySections.keyMatrimonioNominaAssistenteLegaleSposa] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyMatrimonioNominaAssistenteLegaleSposa]
            ),
            isRequiredFromOtherAccordion: isTutore || isCuratore,
          },
        };
      }

      if (ageDefect) {
        newValues = {
          ...newValues,
          [KeySections.keyMatrimonioAutorizzazioneDifettoEta]: {
            ...(ageDefect !== '1'
              ? formContext.values[KeySections.keyMatrimonioAutorizzazioneDifettoEta] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyMatrimonioAutorizzazioneDifettoEta]
            ),
            isRequiredFromOtherAccordion: ageDefect !== '1',
          },
        };
      }

      if (typeof isTemporaryBanRemarriage === 'boolean') {
        newValues = {
          ...newValues,
          [KeySections.keyMatrimonioAutorizzazioneDivietoTemp]: {
            ...(isTemporaryBanRemarriage
              ? formContext.values[KeySections.keyMatrimonioAutorizzazioneDivietoTemp] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyMatrimonioAutorizzazioneDivietoTemp]
            ),
            isRequiredFromOtherAccordion: isTemporaryBanRemarriage,
          },
        };
      }

      if (relationship) {
        newValues = {
          ...newValues,
          [KeySections.keyMatrimonioAutorizzazioneParentela]: {
            ...(relationship !== '0'
              ? formContext.values[KeySections.keyMatrimonioAutorizzazioneParentela] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyMatrimonioAutorizzazioneParentela]
            ),
            isRequiredFromOtherAccordion: relationship !== '0',
          },
        };
      }

      if (typeof isLawyerHusband === 'boolean') {
        const currentKey = Boolean(formContext.values[KeySubjects.keyAvvoc1])
          ? KeySubjects.keyAvvoc1
          : Boolean(formContext.values[KeySubjects.keyAvvoc3])
          ? KeySubjects.keyAvvoc3
          : KeySubjects.keyAvvocUc1;

        newValues = {
          ...newValues,
          [currentKey]: {
            ...dataMaintenanceSubject(formContext.values[currentKey]),
            generality: {
              ...(formContext.values[currentKey]?.generality || initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isLawyerHusband,
              idSubject: formContext.values[currentKey]?.generality?.idSubject,
            },
          } as ParentVM,
        };
      }

      if (typeof isLawyerWife === 'boolean') {
        const currentKey = Boolean(formContext.values[KeySubjects.keyAvvoc2])
          ? KeySubjects.keyAvvoc2
          : Boolean(formContext.values[KeySubjects.keyAvvoc4])
          ? KeySubjects.keyAvvoc4
          : KeySubjects.keyAvvocUc2;

        newValues = {
          ...newValues,
          [currentKey]: {
            ...dataMaintenanceSubject(formContext.values[currentKey]),
            generality: {
              ...(formContext.values[currentKey]?.generality || initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isLawyerWife,
              idSubject: formContext.values[currentKey]?.generality?.idSubject,
            },
          } as ParentVM,
        };
      }

      if (typeSeparation) {
        newValues = {
          ...newValues,
          [KeySections.keyProvvedimentoSeparazione]: {
            ...(typeSeparation === IDTypeSeparation.Provvedimento
              ? formContext.values[KeySections.keyProvvedimentoSeparazione] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyProvvedimentoSeparazione]),
            isRequiredFromOtherAccordion: typeSeparation === IDTypeSeparation.Provvedimento,
          },
          [KeySections.keyNegoziazioneAssistita]: {
            ...(typeSeparation === IDTypeSeparation.NegoziazioneAssistita
              ? formContext.values[KeySections.keyNegoziazioneAssistita] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyNegoziazioneAssistita]),
            isRequiredFromOtherAccordion: typeSeparation === IDTypeSeparation.NegoziazioneAssistita,
          },
          [KeySections.keyAccordoSeparazione]: {
            ...(typeSeparation === IDTypeSeparation.Accordo ||
            typeSeparation === IDTypeSeparation.NegoziazioneAssistita ||
            typeSeparation === IDTypeSeparation.AccordoCheHaDeterminatoIlDivorzio
              ? formContext.values[KeySections.keyAccordoSeparazione] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAccordoSeparazione]),
            isRequiredFromOtherAccordion:
              typeSeparation === IDTypeSeparation.Accordo ||
              typeSeparation === IDTypeSeparation.NegoziazioneAssistita ||
              typeSeparation === IDTypeSeparation.AccordoCheHaDeterminatoIlDivorzio,
          },
          [KeySections.keyConfermaAccordoSep]: {
            ...(typeSeparation === IDTypeSeparation.Accordo ||
            typeSeparation === IDTypeSeparation.AccordoCheHaDeterminatoIlDivorzio
              ? formContext.values[KeySections.keyConfermaAccordoSep] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyConfermaAccordoSep]),
            isRequiredFromOtherAccordion:
              typeSeparation === IDTypeSeparation.Accordo ||
              typeSeparation === IDTypeSeparation.AccordoCheHaDeterminatoIlDivorzio,
          },
        };
      }

      if (typeof isReceivedPrivateCitizen === 'boolean') {
        if (
          formContext.values[KeySections.keyDatiAutoritaMittente] &&
          (formContext.values[KeySections.keyDatiAutoritaMittente] as SectionVM).typePresence ===
            typePresence.Condizionato
        ) {
          // solamente se la sezione è condizionata, controllo necessario perchè usato in altri UC
          newValues = {
            ...newValues,
            [KeySections.keyDatiAutoritaMittente]: {
              ...(!isReceivedPrivateCitizen
                ? formContext.values[KeySections.keyDatiAutoritaMittente] || initialValuesSections
                : initialValuesSections),
              ...dataMaintenanceSection(formContext.values[KeySections.keyDatiAutoritaMittente]),
              isRequiredFromOtherAccordion: !isReceivedPrivateCitizen,
            },
          };
        }
        newValues = {
          ...newValues,
          [KeySubjects.keyRichiedente]: {
            ...dataMaintenanceSubject(valuesRichiedente),
            generality: {
              ...(isReceivedPrivateCitizen
                ? (valuesRichiedente || {})?.generality || initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isReceivedPrivateCitizen,
              idSubject: valuesRichiedente?.generality?.idSubject,
            },
          } as ParentVM,
        };
      }

      if (typeof isLastStepEmergencyCurr === 'boolean') {
        const dataFormazioneAtto = dateFormationAct
          ? DateTime.fromISO(dateFormationAct)
          : undefined;

        newValues = {
          ...newValues,
          [KeySections.keyDatiRegistroEmergenza]: {
            ...(isLastStepEmergencyCurr
              ? formContext.values[KeySections.keyDatiRegistroEmergenza] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyDatiRegistroEmergenza]),
            reasonRecovery: isLastStepEmergencyCurr ? '4' : '',
            effectiveDate: dataFormazioneAtto || null,
            effectiveTime: dataFormazioneAtto || null,
            isRequiredFromOtherAccordion: isLastStepEmergencyCurr,
          } as SectionVM,
        };
      }

      if (typeof isSonUnderFourteen === 'boolean') {
        newValues = {
          ...newValues,
          [KeySections.keyAssensoFiglio]: {
            ...(!isSonUnderFourteen
              ? formContext.values[KeySections.keyAssensoFiglio] || initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyAssensoFiglio]),
            isRequiredFromOtherAccordion: !isSonUnderFourteen,
          },
        };
      }

      if (typeof isChangeSurnameName === 'boolean') {
        newValues = {
          ...newValues,
          [KeySubjects.keyIntest2]: {
            ...dataMaintenanceSubject(formContext.values[KeySubjects.keyIntest2] || {}),
            generality: {
              ...(isChangeSurnameName
                ? (formContext.values[KeySubjects.keyIntest2] || {})?.generality ||
                  initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isChangeSurnameName,
            },
          } as ParentVM,
        };
      }

      if (typeof isReceivedByPost === 'boolean') {
        newValues = {
          ...newValues,
          [KeySections.keyDatiEventoCittadinanza]: {
            ...(formContext.values[KeySections.keyDatiEventoCittadinanza] || initialValuesSections),
            ...dataMaintenanceSection(formContext.values[KeySections.keyDatiEventoCittadinanza]),
            isRequiredFromOtherAccordion: isReceivedByPost,
          },
          [KeySections.keyDatiTrascrizioneCittadinanza]: {
            ...(formContext.values[KeySections.keyDatiTrascrizioneCittadinanza] ||
              initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyDatiTrascrizioneCittadinanza]
            ),
            isRequiredFromOtherAccordion: !isReceivedByPost,
          },
        };
      }

      if (typeApplicant) {
        newValues = {
          ...newValues,
          [KeySubjects.keyRichiedentePrivato]: {
            ...dataMaintenanceSubject(valuesRichiedentePrivato),
            generality: {
              ...(typeApplicant === ID_TYPE_APPLICANT.Privato
                ? (valuesRichiedentePrivato || {})?.generality || initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: typeApplicant === ID_TYPE_APPLICANT.Privato,
            },
          } as ParentVM,
          [KeySections.keyDatiTrascrizioneRichiedente]: {
            ...(typeApplicant === ID_TYPE_APPLICANT.Pubblico
              ? formContext.values[KeySections.keyDatiTrascrizioneRichiedente] ||
                initialValuesSections
              : initialValuesSections),
            ...dataMaintenanceSection(
              formContext.values[KeySections.keyDatiTrascrizioneRichiedente]
            ),
            isRequiredFromOtherAccordion: typeApplicant === ID_TYPE_APPLICANT.Pubblico,
          },
        };
      }

      if (numberHolders) {
        const listKeys = numberCondition(numberHolders) || [];

        keyAllHolders?.forEach((item) => {
          const keyHolder = `subject-${item}`;
          const valuesCurr = formContext.values[keyHolder];
          const isRequiredFromOtherAccordion = listKeys.includes(item);

          newValues = {
            ...newValues,
            [keyHolder]: {
              ...dataMaintenanceSubject(valuesCurr),
              generality: {
                ...(isRequiredFromOtherAccordion
                  ? (valuesCurr || {})?.generality || initialValuesParent?.generality
                  : initialValuesParent?.generality),
                isRequiredFromOtherAccordion,
                idSubject: isRequiredFromOtherAccordion
                  ? valuesCurr?.generality?.idSubject
                  : undefined,
              },
            } as ParentVM,
          };
        });
      }

      if (numberChildren) {
        const listKeys = numberCondition(numberChildren, true) || [];

        keyAllChildren?.forEach((item) => {
          const keySon = `subject-${item}`;
          const valuesCurr = formContext.values[keySon];
          const isRequiredFromOtherAccordion = listKeys.includes(item);

          newValues = {
            ...newValues,
            [keySon]: {
              ...dataMaintenanceSubject(valuesCurr),
              generality: {
                ...(isRequiredFromOtherAccordion
                  ? (valuesCurr || {})?.generality || initialValuesParent?.generality
                  : initialValuesParent?.generality),
                isRequiredFromOtherAccordion,
                idSubject: isRequiredFromOtherAccordion
                  ? valuesCurr?.generality?.idSubject
                  : undefined,
              },
            } as ParentVM,
          };
        });
      }

      if (typeof isLawyerHusbandWife === 'boolean') {
        newValues = {
          ...newValues,
          [KeySubjects.keyAvvoc5]: {
            ...dataMaintenanceSubject(valuesAvvoc5),
            generality: {
              ...(isLawyerHusbandWife
                ? (valuesAvvoc5 || {})?.generality || initialValuesParent?.generality
                : initialValuesParent?.generality),
              isRequiredFromOtherAccordion: isLawyerHusbandWife,
            },
          } as ParentVM,
        };
      }

      // settare lo stato in un unico punto
      formContext.setValues(newValues);
    }
  );

  const controllSentenceRecognition = useEventCallback((sentenceRecognition?: string) => {
    setDependentData(undefined, sentenceRecognition);
  });

  const controllSentenceRecognitionNameSurname = useEventCallback(
    (sentenceRecognition?: string) => {
      setDependentData(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        sentenceRecognition
      );
    }
  );

  const controllParentTransmittedCitizenship = useEventCallback(
    (parentTransmittedCitizenship?: string) => {
      setDependentData(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        parentTransmittedCitizenship
      );
    }
  );

  const controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence =
    useEventCallback(
      (
        typologyConsentAndConfiguration?: ItemVM,
        typeDeclaration?: string,
        parentRecognition?: string,
        isIncestuousSonSentence?: boolean
      ) => {
        setDependentData(
          undefined,
          undefined,
          typologyConsentAndConfiguration,
          typeDeclaration,
          isIncestuousSonSentence,
          undefined,
          parentRecognition,
          undefined,
          parentRecognition
        );
      }
    );

  const controllIsPaternitySentence = useEventCallback((isPaternitySentence?: boolean) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      isPaternitySentence
    );
  });

  const controllParentRecognitionMadrePadreRiconoscimento = useEventCallback(
    (parentRecognition?: string) => {
      setDependentData(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        parentRecognition,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        parentRecognition
      );
    }
  );

  const controllIntNasCivilStatus = useEventCallback((intNasCivilStatus?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      intNasCivilStatus
    );
  });

  const controllApplicant = useEventCallback((applicant?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      applicant
    );
  });

  const controllParentChangedSurname = useEventCallback((parentChangedSurname?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      parentChangedSurname
    );
  });

  const controllMeasureExchangeSurname = useEventCallback((measureExchangeSurname?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      measureExchangeSurname
    );
  });

  const controllOpposition = useEventCallback((opposition?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      opposition
    );
  });

  const controllGenericImpediment = useEventCallback((genericImpediment?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      genericImpediment
    );
  });

  const controllImpedimentUnitedCivilly = useEventCallback((impedimentUnitedCivilly?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      impedimentUnitedCivilly
    );
  });

  const controllPropertyRegime = useEventCallback((propertyRegime?: string, ageDefect?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      propertyRegime,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      ageDefect
    );
  });

  const controllNumberWitnesses = useEventCallback((numberWitnesses?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      numberWitnesses
    );
  });

  const controllPublication = useEventCallback((publication?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      publication
    );
  });

  const controllMinorGroomAssistance = useEventCallback((minorGroomAssistance?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      minorGroomAssistance
    );
  });

  const controllMinorWifeAssistance = useEventCallback((minorWifeAssistance?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      minorWifeAssistance
    );
  });

  const controllAgeDefect = useEventCallback((ageDefect?: string, propertyRegime?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      propertyRegime,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      ageDefect
    );
  });

  const controllTemporaryBanRemarriage = useEventCallback((isTemporaryBanRemarriage?: boolean) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      isTemporaryBanRemarriage
    );
  });

  const controllRelationship = useEventCallback((relationship?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      relationship
    );
  });

  const controllLawyerHusbandWife = useEventCallback(
    (isLawyerHusband?: boolean, isLawyerWife?: boolean) => {
      setDependentData(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        isLawyerHusband,
        isLawyerWife
      );
    }
  );

  const controllTypeSeparation = useEventCallback((typeSeparation?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      typeSeparation
    );
  });

  const controllIsReceivedPrivateCitizen = useEventCallback(
    (isReceivedPrivateCitizen?: boolean) => {
      setDependentData(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        isReceivedPrivateCitizen
      );
    }
  );

  const controllIsSonUnderFourteen = useEventCallback((isSonUnderFourteen?: boolean) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      isSonUnderFourteen
    );
  });

  const controllIsChangeSurnameName = useEventCallback((isChangeSurnameName?: boolean) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      isChangeSurnameName
    );
  });

  const controllIsReceivedByPost = useEventCallback((isReceivedByPost?: boolean) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      isReceivedByPost
    );
  });

  const controllDecedutoCivilStatus = useEventCallback((decedutoCivilStatus?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      decedutoCivilStatus
    );
  });

  const controllIsLastStepEmergency = useEventCallback(() => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      isLastStepEmergency
    );
  });

  const controllTypeApplicant = useEventCallback((typeApplicant?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      typeApplicant
    );
  });

  const controllNumberHolders = useEventCallback((numberHolders?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      numberHolders
    );
  });

  const controllNumberChildren = useEventCallback((numberChildren?: string) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      numberChildren
    );
  });

  const controllIsLawyerHusbandWife = useEventCallback((isLawyerHusbandWife?: boolean) => {
    setDependentData(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      isLawyerHusbandWife
    );
  });

  useEffect(() => {
    controllIsLastStepEmergency();
  }, [isLastStepEmergency]);

  const setDataInterprete = useEventCallback((isWithInterprete?: boolean) => {
    setDependentData(isWithInterprete);
  });

  // Ricalcola tutti i flag isRequiredFromOtherAccordion a partire dai valori
  // correnti del form. Estratto in un callback stabile per poterlo invocare sia
  // al mount sia quando, in modifica, i dati vengono caricati in modo asincrono.
  const initializeDependentDataFromValues = useEventCallback(() => {
    const isWithInterprete = withInterprete(formContext.values);

    if (
      isWithInterprete ||
      valuesDatiSpecificiCittadinanza?.sentenceRecognition ||
      valuesDatiGenerali?.typologyConsent ||
      valuesDatiGenerali?.typeDeclaration ||
      valuesGenitoreTrasmetteCittadinanza?.parentTransmittedCitizenship ||
      valuesRicGenitoreItaliano?.parentRecognition ||
      valuesIntestNas?.generality?.civilStatusItem?.id ||
      valuesDatiGenerali?.parentRecognition ||
      valuesDatiTrascrizione?.parentRecognition ||
      valuesDatiGenerali?.isPaternitySentence ||
      Boolean(valuesDatiGenerali) ||
      valuesDatiGenerali?.isIncestuousSonSentence ||
      valuesDatiTrascrizione?.isPaternitySentence ||
      Boolean(valuesDatiTrascrizione) ||
      valuesDatiTrascrizione?.applicant ||
      valuesDatiTrascrizione?.parentChangedSurname ||
      valuesDatiTrascrizione?.measureExchangeSurname ||
      valuesSpecificCivilUnionMarriage?.opposition ||
      valuesSpecificCivilUnionMarriage?.genericImpediment ||
      valuesRegimePatrimoniale?.propertyRegime ||
      valuesSpecificCivilUnionMarriage?.numberWitnesses ||
      valuesSpecificCivilUnionMarriage?.impedimentUnitedCivilly ||
      valuesSpecificCivilUnionMarriage?.publication ||
      valuesSpecificCivilUnionMarriage?.minorGroomAssistance ||
      valuesSpecificCivilUnionMarriage?.minorWifeAssistance ||
      valuesSpecificCivilUnionMarriage?.ageDefect ||
      valuesSpecificCivilUnionMarriage?.isTemporaryBanRemarriage ||
      valuesSpecificCivilUnionMarriage?.relationship ||
      valuesDatiSepar?.isLawyerHusband ||
      valuesDatiSepar?.isLawyerWife ||
      valuesDatiSepar?.typeSeparation ||
      valuesDatiGenerali?.typeSeparation ||
      valuesDatiSepar?.isReceivedPrivateCitizen ||
      valuesDatiTrascrizione?.isReceivedPrivateCitizen ||
      valuesSpecificCivilUnionMarriage?.isSonUnderFourteen ||
      valuesSpecificCivilUnionMarriage?.typologyConsent ||
      valuesDatiGenerali?.receiptDocument ||
      valuesIntest1?.generality?.isChangeSurnameName ||
      typeof valuesTrascrizioneCittadinanza?.isReceivedByPost === 'boolean' ||
      valuesDeceduto?.generality?.civilStatusItem?.id ||
      valuesDatiTrascrizione?.typeApplicant ||
      valuesDatiTrascrizione?.numberHolders ||
      valuesDatiTrascrizione?.numberChildren ||
      valuesDatiSepar.isLawyerHusbandWife
    ) {
      setDependentData(
        isWithInterprete,
        valuesDatiSpecificiCittadinanza?.sentenceRecognition,
        {
          id:
            valuesDatiGenerali?.configuration ||
            valuesSpecificCivilUnionMarriage?.configuration ||
            '',
          value:
            valuesDatiGenerali?.typologyConsent ||
            valuesSpecificCivilUnionMarriage?.typologyConsent ||
            '',
        },
        valuesDatiGenerali?.typeDeclaration,
        valuesDatiGenerali?.isIncestuousSonSentence || false,
        valuesGenitoreTrasmetteCittadinanza?.parentTransmittedCitizenship,
        valuesRicGenitoreItaliano?.parentRecognition ||
          valuesDatiGenerali?.parentRecognition ||
          valuesDatiTrascrizione?.parentRecognition,
        valuesIntestNas?.generality?.civilStatusItem?.id?.toString(),
        valuesDatiGenerali?.parentRecognition,
        valuesDatiGenerali?.isPaternitySentence ||
          valuesDatiTrascrizione?.isPaternitySentence ||
          false,
        valuesDatiTrascrizione?.sentenceRecognition,
        valuesDatiTrascrizione?.applicant?.id?.toString(),
        valuesDatiTrascrizione?.parentRecognition,
        valuesDatiTrascrizione?.parentChangedSurname,
        valuesDatiTrascrizione?.measureExchangeSurname,
        valuesSpecificCivilUnionMarriage?.opposition,
        valuesSpecificCivilUnionMarriage?.genericImpediment,
        valuesRegimePatrimoniale?.propertyRegime,
        valuesSpecificCivilUnionMarriage?.numberWitnesses,
        valuesSpecificCivilUnionMarriage?.impedimentUnitedCivilly,
        valuesSpecificCivilUnionMarriage?.publication,
        valuesSpecificCivilUnionMarriage?.minorGroomAssistance,
        valuesSpecificCivilUnionMarriage?.minorWifeAssistance,
        valuesSpecificCivilUnionMarriage?.ageDefect,
        valuesSpecificCivilUnionMarriage?.isTemporaryBanRemarriage,
        valuesSpecificCivilUnionMarriage?.relationship,
        valuesDatiSepar?.isLawyerHusband ||
          valuesDatiGenerali?.receiptDocument === IDLawer.AvvocatoMarito ||
          valuesDatiGenerali?.receiptDocument === IDLawer.AvvocatoEntrambi,
        valuesDatiSepar?.isLawyerWife ||
          valuesDatiGenerali?.receiptDocument === IDLawer.AvvocatoMoglie ||
          valuesDatiGenerali?.receiptDocument === IDLawer.AvvocatoEntrambi,
        valuesDatiSepar?.typeSeparation || valuesDatiGenerali?.typeSeparation,
        valuesDatiSepar?.isReceivedPrivateCitizen ||
          valuesDatiTrascrizione?.isReceivedPrivateCitizen,
        valuesSpecificCivilUnionMarriage?.isSonUnderFourteen,
        valuesIntest1.generality?.isChangeSurnameName,
        valuesTrascrizioneCittadinanza?.isReceivedByPost,
        valuesDeceduto?.generality?.civilStatusItem?.id?.toString(),
        isLastStepEmergency,
        valuesDatiTrascrizione?.typeApplicant,
        valuesDatiTrascrizione?.numberHolders,
        valuesDatiTrascrizione?.numberChildren,
        valuesDatiSepar.isLawyerHusbandWife
      );
    }
  });

  // Init al mount (nuovo atto: i valori sono già disponibili).
  useEffect(() => {
    initializeDependentDataFromValues();
  }, []);

  // In modifica il Formik viene reinizializzato (enableReinitialize) con i dati
  // caricati in modo asincrono: l'effect di mount gira quando i valori sono
  // ancora vuoti. Rilanciamo l'init una sola volta, appena i trigger che
  // determinano l'obbligatorietà delle sezioni condizionate risultano valorizzati.
  const hasInitializedDependentData = useRef(false);
  useEffect(() => {
    if (hasInitializedDependentData.current) {
      return;
    }

    const areEditTriggersReady = Boolean(
      valuesIntestNas?.generality?.civilStatusItem?.id ||
        valuesDatiTrascrizione?.applicant?.id ||
        valuesDeceduto?.generality?.civilStatusItem?.id
    );

    if (!areEditTriggersReady) {
      return;
    }

    hasInitializedDependentData.current = true;
    initializeDependentDataFromValues();
  }, [
    valuesIntestNas?.generality?.civilStatusItem?.id,
    valuesDatiTrascrizione?.applicant?.id,
    valuesDeceduto?.generality?.civilStatusItem?.id,
  ]);

  const sezioniUseCaseDataPreSubjects = useMemo(() => {
    return sezioniUseCaseData?.filter((item) => item.posizione === 'A') || [];
  }, [sezioniUseCaseData]);

  const sezioniUseCaseDataPostSubjects = useMemo(() => {
    return sezioniUseCaseData?.filter((item) => item.posizione === 'B') || [];
  }, [sezioniUseCaseData]);

  return (
    <Grid item xs={12}>
      {sezioniUseCaseDataPreSubjects.length ? (
        <Sections
          formContext={formContext}
          sezioniUseCaseData={sezioniUseCaseDataPreSubjects}
          onSaveSection={onSaveSection}
          disabled={disabled}
          tipoEvento={tipoEvento}
          idUseCase={idUseCase}
          idEvento={idEvento}
          dateFormationAct={dateFormationAct}
          setDataInterprete={setDataInterprete}
          controllSentenceRecognition={controllSentenceRecognition}
          controllSentenceRecognitionNameSurname={controllSentenceRecognitionNameSurname}
          controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence={
            controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence
          }
          controllIsPaternitySentence={controllIsPaternitySentence}
          controllParentTransmittedCitizenship={controllParentTransmittedCitizenship}
          controllParentRecognitionMadrePadreRiconoscimento={
            controllParentRecognitionMadrePadreRiconoscimento
          }
          controllParentChangedSurname={controllParentChangedSurname}
          controllApplicant={controllApplicant}
          controllMeasureExchangeSurname={controllMeasureExchangeSurname}
          controllOpposition={controllOpposition}
          controllGenericImpediment={controllGenericImpediment}
          controllImpedimentUnitedCivilly={controllImpedimentUnitedCivilly}
          controllPublication={controllPublication}
          controllMinorGroomAssistance={controllMinorGroomAssistance}
          controllMinorWifeAssistance={controllMinorWifeAssistance}
          controllAgeDefect={controllAgeDefect}
          controllTemporaryBanRemarriage={controllTemporaryBanRemarriage}
          controllRelationship={controllRelationship}
          controllNumberWitnesses={controllNumberWitnesses}
          controllPropertyRegime={controllPropertyRegime}
          controllLawyerHusbandWife={controllLawyerHusbandWife}
          controllTypeSeparation={controllTypeSeparation}
          controllIsLawyerHusbandWife={controllIsLawyerHusbandWife}
          controllIsReceivedPrivateCitizen={controllIsReceivedPrivateCitizen}
          controllIsSonUnderFourteen={controllIsSonUnderFourteen}
          controllIsReceivedByPost={controllIsReceivedByPost}
          controllTypeApplicant={controllTypeApplicant}
          controllNumberHolders={controllNumberHolders}
          controllNumberChildren={controllNumberChildren}
          isLastStepEmergency={isLastStepEmergency}
        />
      ) : undefined}
      <Subjects
        formContext={formContext}
        soggettiUseCaseData={soggettiUseCaseData}
        onSaveSubject={onSaveSubject}
        idEvento={idEvento}
        disabled={disabled}
        dateFormationAct={dateFormationAct}
        withReasonDelay={withReasonDelay}
        setDataInterprete={setDataInterprete}
        controllIntNasCivilStatus={controllIntNasCivilStatus}
        controllDecedutoCivilStatus={controllDecedutoCivilStatus}
        controllIsChangeSurnameName={controllIsChangeSurnameName}
        isStepFromEmergency={isStepFromEmergency}
        isLastStepEmergency={isLastStepEmergency}
        tipoEvento={tipoEvento}
      />
      {sezioniUseCaseDataPostSubjects.length ? (
        <Sections
          formContext={formContext}
          sezioniUseCaseData={sezioniUseCaseDataPostSubjects}
          onSaveSection={onSaveSection}
          disabled={disabled}
          tipoEvento={tipoEvento}
          idUseCase={idUseCase}
          idEvento={idEvento}
          dateFormationAct={dateFormationAct}
          setDataInterprete={setDataInterprete}
          controllSentenceRecognition={controllSentenceRecognition}
          controllSentenceRecognitionNameSurname={controllSentenceRecognitionNameSurname}
          controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence={
            controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence
          }
          controllIsPaternitySentence={controllIsPaternitySentence}
          controllParentTransmittedCitizenship={controllParentTransmittedCitizenship}
          controllParentRecognitionMadrePadreRiconoscimento={
            controllParentRecognitionMadrePadreRiconoscimento
          }
          controllParentChangedSurname={controllParentChangedSurname}
          controllApplicant={controllApplicant}
          controllMeasureExchangeSurname={controllMeasureExchangeSurname}
          controllOpposition={controllOpposition}
          controllGenericImpediment={controllGenericImpediment}
          controllImpedimentUnitedCivilly={controllImpedimentUnitedCivilly}
          controllPublication={controllPublication}
          controllMinorGroomAssistance={controllMinorGroomAssistance}
          controllMinorWifeAssistance={controllMinorWifeAssistance}
          controllAgeDefect={controllAgeDefect}
          controllTemporaryBanRemarriage={controllTemporaryBanRemarriage}
          controllRelationship={controllRelationship}
          controllNumberWitnesses={controllNumberWitnesses}
          controllPropertyRegime={controllPropertyRegime}
          controllLawyerHusbandWife={controllLawyerHusbandWife}
          controllTypeSeparation={controllTypeSeparation}
          controllIsLawyerHusbandWife={controllIsLawyerHusbandWife}
          controllIsReceivedPrivateCitizen={controllIsReceivedPrivateCitizen}
          controllIsSonUnderFourteen={controllIsSonUnderFourteen}
          controllIsReceivedByPost={controllIsReceivedByPost}
          isLastStepEmergency={isLastStepEmergency}
          controllTypeApplicant={controllTypeApplicant}
          controllNumberHolders={controllNumberHolders}
          controllNumberChildren={controllNumberChildren}
        />
      ) : undefined}
      {isLastStepEditAct ? undefined : (
        <Document
          formContext={formContext}
          idEvento={idEvento}
          codLastStep={codLastStep}
          disabled={disabled}
          isLastStepEmergency={isLastStepEmergency}
          isStepFromEmergency={isStepFromEmergency}
        />
      )}
      {isStepFromEmergency ? undefined : (
        <TextAct
          formContext={formContext}
          disabled={disabled}
          callGetTextAct={callGetTextAct}
          onSaveText={onSaveText}
          disabledValid={disabledValid}
          disabledEmergency={disabledEmergency}
          isLastStepEmergency={isLastStepEmergency}
          isLastStepEditAct={isLastStepEditAct}
        />
      )}
      {isLastStepEmergency ? (
        <DocumentEmergency formContext={formContext} idEvento={idEvento} />
      ) : undefined}
      {isLastStepEditAct ? (
        <TextAnnotationOld formContext={formContext} disabled={disabled} />
      ) : undefined}
    </Grid>
  );
};

LastStepComponent.displayName = 'Last Step Component';

const LastStep = memo(LastStepComponent);

export default LastStep;
